module.exports = __webpack_public_path__ + "img/头像1.f653cce0.png";